import styled from 'styled-components';

export const Wrapper = styled.div`
  border-radius: 5px;
  background-color: ${({theme}) => `
    ${theme.variables.accentBackgroundColor};
  `};
  box-sizing: border-box;
  margin: 18px 0;
  padding: 10px;
`;

export const Preview = styled.img`
  margin-right: 16px;
  vertical-align: middle;
  border-radius: 5px;
  object-fit: cover;
  height: 60px;
  width: 106px;
`;

export const Title = styled.span`
  font-size: 14px;
`;
